/**
 * Theoric — GA Opt-Out para Tráfego Interno
 *
 * COMO FUNCIONA:
 *   Quando localStorage['theoric_internal'] === 'true', este script:
 *   1. Define window['ga-disable-G-4M1XM50GTT'] = true  (desativa o gtag nativo)
 *   2. Substitui window.gtag por uma função no-op
 *   3. Intercepta window.dataLayer com um Proxy que descarta todos os pushes
 *   4. Bloqueia o carregamento do script do Google Tag Manager/Analytics via
 *      um MutationObserver que remove <script src="googletagmanager"> antes
 *      que ele execute (caso seja injetado dinamicamente após este script)
 *
 * ATIVAÇÃO / DESATIVAÇÃO:
 *   - Ativação:   theoric.internal.enable()   ou URL ?theoric_internal=on
 *   - Desativação: theoric.internal.disable()  ou URL ?theoric_internal=off
 *   - Status:     theoric.internal.status()
 *
 * IMPORTANTE: Este script DEVE ser carregado como o PRIMEIRO script da página
 *   (antes do snippet de gtag) para garantir que o bloqueio esteja ativo.
 */

(function () {
  'use strict';

  var GA_ID       = 'G-4M1XM50GTT';
  var STORAGE_KEY = 'theoric_internal';

  /* ── 1. Verifica a flag de modo interno ──────────────────────────────── */
  function isInternal() {
    try { return localStorage.getItem(STORAGE_KEY) === 'true'; } catch (e) { return false; }
  }

  /* ── 2. Ativa ou desativa via URL param (?theoric_internal=on|off) ───── */
  (function handleUrlParam() {
    try {
      var url    = new URL(window.location.href);
      var param  = url.searchParams.get('theoric_internal');
      if (!param) return;

      if (param === 'on') {
        localStorage.setItem(STORAGE_KEY, 'true');
        console.info('[Theoric Internal] Modo interno ATIVADO. GA4 bloqueado neste dispositivo.');
      } else if (param === 'off') {
        localStorage.removeItem(STORAGE_KEY);
        console.info('[Theoric Internal] Modo interno DESATIVADO. GA4 funcionando normalmente.');
      }

      // Remove o param da URL sem recarregar
      url.searchParams.delete('theoric_internal');
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', url.toString());
      }
    } catch (e) { /* noop */ }
  })();

  /* ── 3. Bloqueia tudo se modo interno estiver ativo ─────────────────── */
  if (isInternal()) {

    // 3a. Flag nativa do gtag que desabilita coleta para este ID
    window['ga-disable-' + GA_ID] = true;

    // 3b. Substitui gtag por no-op (antes do snippet carregar)
    window.gtag = function () {
      // no-op silencioso — nenhum dado enviado
    };

    // 3c. Intercepta dataLayer com Proxy para descartar pushes
    var _safeDataLayer = [];
    try {
      window.dataLayer = new Proxy(_safeDataLayer, {
        get: function (target, prop) {
          if (prop === 'push') {
            return function () { /* descarta silenciosamente */ };
          }
          return target[prop];
        }
      });
    } catch (e) {
      // Fallback para browsers sem Proxy (IE11) — sobrescreve push
      window.dataLayer = _safeDataLayer;
      window.dataLayer.push = function () { /* noop */ };
    }

    // 3d. MutationObserver: remove scripts do GTM/GA antes de executarem
    //     (captura injeção dinâmica de scripts de analytics)
    var BLOCKED_PATTERNS = [
      'googletagmanager.com',
      'google-analytics.com',
      'analytics.js',
      'gtag/js'
    ];

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.tagName === 'SCRIPT') {
            var src = node.src || '';
            var shouldBlock = BLOCKED_PATTERNS.some(function (pattern) {
              return src.indexOf(pattern) !== -1;
            });
            if (shouldBlock) {
              node.type = 'javascript/blocked';  // impede execução
              node.parentNode && node.parentNode.removeChild(node);
            }
          }
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    // Desconecta após o DOM carregar (páginas estáticas não precisam de vigilância eterna)
    document.addEventListener('DOMContentLoaded', function () {
      observer.disconnect();
    });

    console.info(
      '%c[Theoric Internal] Modo interno ativo — GA4 bloqueado neste dispositivo.',
      'background:#5a4a42;color:#fff;padding:4px 8px;border-radius:4px;font-weight:bold;'
    );
  }

  /* ── 4. API pública (window.theoric.internal) ────────────────────────── */
  window.theoric = window.theoric || {};
  window.theoric.internal = {
    /* Usado pelo theme.liquid antes de carregar GTM, Clarity e RD Station.
       Faltava desde 08/06/2026: a chamada quebrava e nenhum dos tres carregava. */
    canTrack: function () {
      return !isInternal();
    },
    enable: function () {
      try { localStorage.setItem(STORAGE_KEY, 'true'); } catch (e) {}
      alert('[Theoric] Modo interno ATIVADO.\n\nGA4 será bloqueado a partir do próximo carregamento de página.\n\nRecarregue agora para confirmar.');
    },
    disable: function () {
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      alert('[Theoric] Modo interno DESATIVADO.\n\nGA4 voltará a funcionar normalmente a partir do próximo carregamento.\n\nRecarregue agora para confirmar.');
    },
    status: function () {
      var active = isInternal();
      console.info(
        '%c[Theoric Internal] Status: ' + (active ? 'ATIVO (GA4 bloqueado)' : 'INATIVO (GA4 funcionando)'),
        'background:' + (active ? '#c0392b' : '#27ae60') + ';color:#fff;padding:4px 8px;border-radius:4px;font-weight:bold;'
      );
      return active;
    }
  };

})();
